module.exports = __webpack_public_path__ + "static/givehigher_Logo-8521b85b5579f40475d3633736c099a3.jpg";